import { makeAutoObservable } from 'mobx'
import ModalStore from './ModalStore'
import UserStore from './UserStore'

export class RootStore {
  constructor() {
    makeAutoObservable(this)

    // Initializes the child stores by passing the reference of the rootStore
    this.modalStore = new ModalStore(this)
    this.userStore = new UserStore(this)
  }
}

const rootStore = new RootStore()
export default rootStore
